export const appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationId =
  "/:app_group_id/canvas/:workflow_id/step/:step_id/message/:message_variation_id";
